var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSelect',_vm._g(_vm._b({ref:"BaseSelect",attrs:{"label":_vm.label,"options":_vm.options,"required":_vm.required},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'BaseSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }